<div class="radio-group">
    <div *ngFor="let option of options; let i = index" class="radio-option" (click)="selectOption(option, i)"
        [class.selected]="selectedIndex === i">
        <input type="radio" [checked]="selectedIndex === i" readonly>
        <ng-container *ngTemplateOutlet="template; context: { $implicit: option }"></ng-container>
    </div>
</div>